var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 81,
    viewBox: "0 0 111 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dossier 1",
    clipPath: "url(#clip0_9686_62086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M94.1847 44.1065V4.7417H25V57.7333",
    fill: "#D6C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.9659 39.8647V0.5H18.7812V53.4914",
    fill: "#F9EED7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M99.4039 75.2815V45.4301C99.4039 42.2529 95.8304 39.6774 91.4221 39.6774H55.8923C52.6104 39.6774 49.6633 38.2297 48.4631 36.0283L46.8902 33.1427C45.6903 30.9413 42.7429 29.4937 39.461 29.4937H19.5756C15.1672 29.4937 11.5938 32.0691 11.5938 35.2463V75.2816C11.5938 78.1637 14.8355 80.5001 18.8343 80.5001H92.1635C96.1621 80.4999 99.4039 78.1635 99.4039 75.2815Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.3206 75.2814V35.2461C16.3206 32.0689 19.894 29.4934 24.3024 29.4934H19.5756C15.1672 29.4934 11.5938 32.0689 11.5938 35.2461V75.2814C11.5938 78.1634 14.8355 80.4997 18.8343 80.4997H23.5612C19.5623 80.4997 16.3206 78.1634 16.3206 75.2814Z",
    fill: "#EDBB4C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.3847 18.5769C40.6314 18.5769 44.074 16.0957 44.074 13.035C44.074 9.97435 40.6314 7.49316 36.3847 7.49316C32.138 7.49316 28.6953 9.97435 28.6953 13.035C28.6953 16.0957 32.138 18.5769 36.3847 18.5769Z",
    fill: "#DBCEBA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.6545 13.0355C33.6545 10.6008 35.8338 8.53459 38.8624 7.79037C38.0837 7.59897 37.2497 7.49365 36.3808 7.49365C32.1339 7.49365 28.6914 9.97475 28.6914 13.0355C28.6914 16.0962 32.1339 18.5774 36.3808 18.5774C37.2495 18.5774 38.0837 18.4721 38.8624 18.2807C35.8338 17.5365 33.6545 15.4701 33.6545 13.0355Z",
    fill: "#D6C8B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.6914 24.1193C28.6914 21.0585 32.1339 18.5774 36.3808 18.5774C40.6276 18.5774 44.0701 21.0585 44.0701 24.1193",
    fill: "#FF525D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M78.7846 10.3546H54.1788C53.1999 10.3546 52.4062 9.78253 52.4062 9.07706C52.4062 8.37159 53.1999 7.79956 54.1788 7.79956H78.7846C79.7638 7.79956 80.5571 8.37159 80.5571 9.07706C80.5571 9.78253 79.7638 10.3546 78.7846 10.3546Z",
    fill: "#34ABE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M78.7835 35.3721H68.6866C67.7073 35.3721 66.9141 34.8001 66.9141 34.0946C66.9141 33.3892 67.7075 32.8171 68.6866 32.8171H78.7835C79.7627 32.8171 80.556 33.3892 80.556 34.0946C80.556 34.8001 79.7627 35.3721 78.7835 35.3721Z",
    fill: "#34ABE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M78.7846 29.1177H54.1788C53.1999 29.1177 52.4062 28.5457 52.4062 27.8402C52.4062 27.1348 53.1999 26.5627 54.1788 26.5627H78.7846C79.7638 26.5627 80.5571 27.1348 80.5571 27.8402C80.5571 28.5457 79.7638 29.1177 78.7846 29.1177Z",
    fill: "#34ABE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M78.7846 16.609H54.1788C53.1999 16.609 52.4062 16.0369 52.4062 15.3315C52.4062 14.626 53.1999 14.054 54.1788 14.054H78.7846C79.7638 14.054 80.5571 14.626 80.5571 15.3315C80.5571 16.0371 79.7638 16.609 78.7846 16.609Z",
    fill: "#34ABE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M78.7846 22.8636H54.1788C53.1999 22.8636 52.4062 22.2916 52.4062 21.5861C52.4062 20.8806 53.1999 20.3086 54.1788 20.3086H78.7846C79.7638 20.3086 80.5571 20.8806 80.5571 21.5861C80.5571 22.2916 79.7638 22.8636 78.7846 22.8636Z",
    fill: "#34ABE0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9686_62086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 80,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.f441ea97cbd3a86231a055d0525f6b7d.svg";
export { ForwardRef as ReactComponent };